import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Tokenized "summary / totals card" chrome for order-style breakdowns
 * (Items Subtotal → adjustments → grand total). Built as an interim because
 * the "New Library" Figma DS has no order-summary / totals component — flagged
 * not-yet-in-Figma, same situation as lib-anc-entry-grid / lib-anc-form-alert.
 *
 * It only owns the bordered, right-aligned card frame and an optional title;
 * the consumer projects `lib-anc-summary-row`s (and their own form controls /
 * computed values) so all binding + calculation logic stays in the form.
 *
 * @example
 * <lib-anc-summary-list [title]="'Order Summary'">
 *   <lib-anc-summary-row [label]="'Order Total'" [readonly]="true">
 *     {{ currency }} {{ calculateTotal() }}
 *   </lib-anc-summary-row>
 *   <lib-anc-summary-row [label]="'Shipping Cost'">
 *     <input class="form-control" formControlName="shipping_cost" />
 *   </lib-anc-summary-row>
 *   <lib-anc-summary-row [label]="'Total Amount'" [emphasized]="true">
 *     {{ currency }} {{ calculateOrderTotal() }}
 *   </lib-anc-summary-row>
 * </lib-anc-summary-list>
 */
@Component({
    selector: 'lib-anc-summary-list',
    imports: [CommonModule],
    templateUrl: './anc-summary-list.component.html',
    styleUrls: ['./anc-summary-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncSummaryListComponent {
    /** Optional card heading (e.g. "Order Summary"). Hidden when empty. */
    title = input<string>('');
}
